import { Card } from 'antd';
import React from 'react';
import ProgressBar from '../../components/progressBar';
import { useJourneyDashboardContext } from '../context';

const RouteProgress = React.forwardRef<HTMLDivElement>((props, ref) => {
  const journey = useJourneyDashboardContext();
  return (
    <Card
      bodyStyle={{
        padding: '15px',
      }}
    >
      <ProgressBar journey={journey} />
    </Card>
  );
});

export default RouteProgress;
